module.exports = __webpack_public_path__ + "img/wishlist_n.7746f5e4.svg";